import * as React from "react";
import { Fab } from "@mui/material";
import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";
import { FloatingActionButtonProps } from "./types";
import "./styles.scss";
import Typography from "../typography";

const classNameBase = "scd-floating-action";

export default function FloatingActionButton(
  props: FloatingActionButtonProps,
): React.JSX.Element {
  const { text, alert, disabled, kind, children, onClick } = props;

  const icon = kind === "add" ? <Add /> : <Remove />;
  return (
    <div className={`${classNameBase}-container${disabled ? "-disabled" : ""}`}>
      <Fab
        className={`${classNameBase}-button${disabled ? "-disabled" : ""}`}
        color="primary"
        size="small"
        disabled={disabled}
        onClick={onClick}
      >
        {kind ? icon : children}
      </Fab>
      <Typography
        variant="body2"
        onClick={onClick}
        className={`${classNameBase}-text`}
      >
        {text}
      </Typography>
      {alert && (
        <Typography
          variant="body2"
          onClick={onClick}
          className={`${classNameBase}-text-alert`}
        >
          {alert}
        </Typography>
      )}
    </div>
  );
}
